export const LOGO = "/logo-mimika.png";
export const KOP = {
  pemda: "PEMERINTAH KABUPATEN MIMIKA",
  distrik: "DISTRIK WANIA",
  kelurahan: "KELURAHAN INAUGA",
  alamat: "Alamat : Jl. Sam Ratulangi Gang Ketapang Timika – Papua",
  tempat: "Timika",
};
export const LURAH = {
  nama: "GERSON RUMBARAR, SE, M.Si",
  pangkat: "PENATA TK. I",
  nip: "19810120 201001 1 016",
  jabatan: "Kepala Kelurahan Inauga",
};

export const Kop = () => (
  <div className="flex items-center gap-4 border-b-[3px] border-double border-black pb-2" data-testid="kop-surat">
    <img src={LOGO} alt="Logo Kabupaten Mimika" className="h-[88px] w-auto" />
    <div className="flex-1 text-center leading-tight" style={{ fontFamily: "'Times New Roman', serif" }}>
      <div className="text-[15px] font-bold">{KOP.pemda}</div>
      <div className="text-[15px] font-bold">{KOP.distrik}</div>
      <div className="text-[22px] font-extrabold tracking-wide">{KOP.kelurahan}</div>
      <div className="text-[12px] italic">{KOP.alamat}</div>
    </div>
    <div className="w-[70px]" />
  </div>
);
